import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  readonly toastSubject = new Subject<any>();
  toastState = this.toastSubject.asObservable();

  show(message: string, type: 'success' | 'error' | 'info' = 'info', duration = 6000) {
    this.toastSubject.next({ message, type, show: true });
    if(type !== 'error'){
      setTimeout(() => {
      this.toastSubject.next({ show: false });
    }, duration);
    }
  }

  hide(){
    this.toastSubject.next({ show: false });
  }

}
